// extracted by mini-css-extract-plugin
module.exports = {"chooseTariff":"ChooseTariffPage_chooseTariff__2OPYD","chooseTariff__item":"ChooseTariffPage_chooseTariff__item__2pjnU"};